// frontend/src/shared/styles.js
// Uses JPG assets named like: flare-form.jpg, flare-form1.jpg, ...
// Do the same for gloom-pop, glow-morphic, ragga-puppets, and neonkra.

export const STYLE_DEFS = [
  {
    key: "gloom-pop",
    name: "Gloom Pop",
    status: "ready",
    hint:
      "A candy-lit mushroom dream world. Perfect for playful characters and scenes.",
    img: "/assets/styles/gloom-pop.jpg",
    examples: [
      "/assets/styles/gloom-pop1.jpg",
      "/assets/styles/gloom-pop2.jpg",
      "/assets/styles/gloom-pop3.jpg",
    ],
  },
  {
    key: "flare-form",
    name: "Flare Form",
    status: "in-dev",
    hidden: true, // 🔒 Hidden until ready
    hint:
      "High-contrast highlights, crisp edges, and slightly glossy surfaces. Punchy product looks.",
    img: "/assets/styles/flare-form.jpg",
    examples: [
      "/assets/styles/flare-form1.jpg",
      "/assets/styles/flare-form2.jpg",
      "/assets/styles/flare-form3.jpg",
    ],
  },
  {
    key: "glow-morphic",
    name: "Glow Morphic",
    status: "in-dev",
    hidden: true, // 🔒 Hidden until ready
    hint:
      "Soft, rounded volumes with glow accents and dreamy palettes. Smooth, modern vibes.",
    img: "/assets/styles/glow-morphic.jpg",
    examples: [
      "/assets/styles/glow-morphic1.jpg",
      "/assets/styles/glow-morphic2.jpg",
      "/assets/styles/glow-morphic3.jpg",
    ],
  },
  {
    key: "ragga-puppets",
    name: "Ragga Puppets",
    status: "in-dev",
    hidden: true, // 🔒 Hidden until ready
    hint:
      "Plush felt Caribbean puppets: brown bead eyes, stitched rhythm-line on chest, reggae wardrobe. Scenes: string-lights stage, cozy kitchen, beach or farm. One iconic prop by default.",
    img: "/assets/styles/ragga-puppets.jpg",
    examples: [
      "/assets/styles/ragga-puppets1.jpg",
      "/assets/styles/ragga-puppets2.jpg",
      "/assets/styles/ragga-puppets3.jpg",
    ],
  },
  {
    key: "neonkra",
    name: "Neonkra",
    status: "in-dev",
    hidden: true, // 🔒 Hidden until ready
    hint:
      "Afrofuturistic street-style with tri-tone neon lighting (cyan, magenta, amber). 3D-animated look with smooth surfaces, clean silhouettes, and abstract architectural backgrounds. Modern, joyful aesthetic.",
    img: "/assets/styles/neonkra.jpg",
    examples: [
      "/assets/styles/neonkra1.jpg",
      "/assets/styles/neonkra2.jpg",
      "/assets/styles/neonkra3.jpg",
    ],
  },
];

export const ACTIVE_STYLES = STYLE_DEFS.filter(s => s.status === "ready");
export const ALL_STYLES = STYLE_DEFS;